import BackgroundImages from '../assets/img/bg/background images.png';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import './Authform.css'
import  { useHistory } from  'react-router-dom'
import  axios from '../axios'
import { useStateValue } from '../StateProvider';
import { Data } from 'victory';


function AuthForm({}) {
   const history = useHistory()
   const [username, setusername] = useState('')
   const [password, setpassword] = useState('')
   const [userdata, setuserdata] = useState([])
   const [userinfo, setuserinfo] = useState({})
   const [open ,setopen] = useState(false)
   const[user, dispatch] = useStateValue();

   const login  = async e => {
    e.preventDefault();
   const logidata =  await axios.instance.post('/login', {
    LoginCode: username,
    Password: password
   }).then(res => {
  
    console.log(res.data.eventlist)
       if(Object.keys(res.data).length === 2){
        localStorage.setItem('user', JSON.stringify(res.data))
       
        setuserdata(res.data.eventlist)
        localStorage.setItem('authtoken', 'Bearer '+res.data.token)
       
        
       }
     for (const data of res.data.eventlist) {
      localStorage.setItem('masterrequired', data.Masterrequired)
     }
      dispatch({
        type:"SET_USER",
       user: res.data
      })
    
      if(Object.keys(res.data).length === 2 ){
      history.push('/Home')
    }else {
     
      setopen(true)
    }
    setTimeout(() => {
      setopen(false)
    }, 2000);
    
     
   })

   }

   useEffect(() => {
    localStorage.setItem('cateid', 0)
   }, [])




  return (
    <div>
       <div className="authpage">
        <div className="cardlogin">
      <Form onSubmit={login} >
  
          <div className="text-center pb-4">
            <h1><b>Padma</b></h1> Inspection
          </div>
      
        <FormGroup>
          <Label >User Code</Label>
          <Input  value={username} placeholder="User Code"  onChange={e => setusername(e.target.value)}  />
          {open ? <p className="errors">invalid User Code</p> : ''}
        </FormGroup>
        <FormGroup>
          <Label >Password</Label>
          <Input type="password" value={password} placeholder="password"  onChange={e => setpassword(e.target.value)}/>
          {open ? <p className="errors">invalid password </p> : ''  }
        </FormGroup>
        <hr />
    
        <Button
          size="lg"
          className="bg-gradient-theme-left border-0"
          block
         >
       Login
        </Button>
      
        {userdata.length !=0 ?  userdata.map((data) => (
           localStorage.setItem('userid', data.UserID),
           localStorage.setItem('username', data.LoginName),
           localStorage.setItem('email', data.EmailId),
            localStorage.setItem('usertype', data.UserType)
             
  )): ''}
         
      </Form>
      </div>
      </div>
    </div>
  )
}
export const STATE_LOGIN = 'LOGIN';
export const STATE_SIGNUP = 'SIGNUP';

AuthForm.propTypes = {
  authState: PropTypes.oneOf([STATE_LOGIN, STATE_SIGNUP]).isRequired,
  showLogo: PropTypes.bool,
  usernameLabel: PropTypes.string,
  usernameInputProps: PropTypes.object,
  passwordLabel: PropTypes.string,
  passwordInputProps: PropTypes.object,
  confirmPasswordLabel: PropTypes.string,
  confirmPasswordInputProps: PropTypes.object,
  onLogoClick: PropTypes.func,
};

AuthForm.defaultProps = {
  authState: 'LOGIN',
  showLogo: true,
  usernameLabel: 'Email',
  usernameInputProps: {
    type: 'email',
    placeholder: 'your@email.com',
  },
  passwordLabel: 'Password',
  passwordInputProps: {
    type: 'password',
    placeholder: 'your password',
  },
  confirmPasswordLabel: 'Confirm Password',
  confirmPasswordInputProps: {
    type: 'password',
    placeholder: 'confirm your password',
  },
  onLogoClick: () => {},
};
export default AuthForm
